export default {
  Player: 1,
  Captain: 2
};
